import { TipoDistribuidorEnum } from '../../shared/enum/tipo-distribuidor.enum';
import { OneBadgeVariant } from '../../shared/component/one-badge/one-badge.component';

/** Forma mínima comum a DistribuidorStruct e DistribuidorAdminStruct — permite reusar o rótulo nos dois. */
export interface NoSelecionavel {
  idDistribuidor: number;
  nomeDistribuidor: string;
  idTipoDistribuidor: number;
  idDistribuidorPai: number | null;
}

/** Token antigo (0/undefined) é tratado como Distribuidor, sem privilégios. */
export function tipoEfetivo(tipo: number | null | undefined): TipoDistribuidorEnum {
  return tipo && tipo > 0 ? (tipo as TipoDistribuidorEnum) : TipoDistribuidorEnum.Distribuidor;
}

export function labelTipoDistribuidor(tipo: number | null | undefined): string {
  switch (tipoEfetivo(tipo)) {
    case TipoDistribuidorEnum.EasyERP: return 'OWNER';
    case TipoDistribuidorEnum.Master: return 'Master';
    case TipoDistribuidorEnum.Interno: return 'Interno';
    default: return 'Distribuidor';
  }
}

export function varianteBadgeTipo(tipo: number | null | undefined): OneBadgeVariant {
  switch (tipoEfetivo(tipo)) {
    case TipoDistribuidorEnum.EasyERP: return 'warning';
    case TipoDistribuidorEnum.Master: return 'info';
    case TipoDistribuidorEnum.Interno: return 'success';
    default: return 'default';
  }
}

/** Ícone do badge de tipo: estrela no OWNER (tipo 1); os demais tipos não levam ícone. */
export function iconeBadgeTipo(tipo: number | null | undefined): string {
  return tipoEfetivo(tipo) === TipoDistribuidorEnum.EasyERP ? 'star' : '';
}

/** Espelho de DistribuidorHierarquia.PodeCriar (I5). O backend é a defesa; aqui só se decide o que oferecer no select. */
export function tiposCriaveisPor(tipoLogado: number | null | undefined): TipoDistribuidorEnum[] {
  switch (tipoEfetivo(tipoLogado)) {
    case TipoDistribuidorEnum.EasyERP: return [TipoDistribuidorEnum.Master, TipoDistribuidorEnum.Distribuidor, TipoDistribuidorEnum.Interno];
    case TipoDistribuidorEnum.Master: return [TipoDistribuidorEnum.Distribuidor, TipoDistribuidorEnum.Interno];
    default: return [];
  }
}

/** "Nome · Tipo"; Interno acrescenta o pai porque "ATS Sul" sozinho não diz de quem é. */
export function rotuloNoParaSelecao(no: NoSelecionavel, lista: NoSelecionavel[]): string {
  let rotulo = `${no.nomeDistribuidor} · ${labelTipoDistribuidor(no.idTipoDistribuidor)}`;
  if (tipoEfetivo(no.idTipoDistribuidor) === TipoDistribuidorEnum.Interno && no.idDistribuidorPai != null) {
    const pai = lista.find(d => d.idDistribuidor === no.idDistribuidorPai);
    if (pai) rotulo += ` (${pai.nomeDistribuidor})`;
  }
  return rotulo;
}

export function exibirToggleGod(noAlvo: { idTipoDistribuidor: number }, logado: { isGodOriginal: boolean }): boolean {
  return !!logado.isGodOriginal && tipoEfetivo(noAlvo.idTipoDistribuidor) === TipoDistribuidorEnum.EasyERP;
}

export function podeDesativarNo(no: { idTipoDistribuidor: number }): boolean {
  return tipoEfetivo(no.idTipoDistribuidor) !== TipoDistribuidorEnum.EasyERP;
}
